export { DoctorService } from './doctor/doctor.service';
export { HospitalsService } from './hospitals/hospitals.service';
export { SettingsService } from './settings/settings.service';
export { SharedService } from './shared/shared.service';
export { SidebarService } from './sidebar/sidebar.service';
export { UserService } from './user/user.service';
export { UploadFileService } from './upload-file/upload-file.service';
export { LoginGuard } from './../guards/login.guard';
export { AdminGuard } from '../guards/admin.guard';
export { VerifyTokenGuard } from '../guards/verify-token.guard';


// WEBPACK FOOTER //
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/services/service.index.ts